import { Plus, Redo2, Undo2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import type { useScenarios } from '@/hooks/useScenarios'
import Button from '@/components/common/Button'

interface RouteEditToolbarProps {
  s: ReturnType<typeof useScenarios>
}

// ルート編集・新規作成モードのフローティングツールバー（マップ上部中央）。
// マーク追加 / Undo / Redo とキャンセル / 保存をマップ上にまとめて置く。
export default function RouteEditToolbar({ s }: RouteEditToolbarProps) {
  const { t } = useTranslation()
  const re = s.routeEdit
  if (!re.isActive) return null

  const saveLabel = re.isCreatingRoute
    ? t('scenarios.register')
    : t('scenarios.routeEditSave')

  return (
    <div className="absolute top-2 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-1.5">
      <div className="flex items-center gap-1.5 bg-white/95 rounded-lg shadow px-2 py-1.5">
        <Button
          onClick={re.toggleAddMode}
          variant={re.isAddingMark ? 'blue' : 'white'}
          size="sm"
          className="flex items-center gap-1"
        >
          <Plus size={14} />
          {t('scenarios.addMark')}
        </Button>
        <div className="w-px h-5 bg-gray-200" />
        <Button
          onClick={re.handleUndo}
          disabled={!re.canUndo}
          variant="white"
          size="sm"
          className="p-1.5"
          title={t('scenarios.undo')}
        >
          <Undo2 size={15} />
        </Button>
        <Button
          onClick={re.handleRedo}
          disabled={!re.canRedo}
          variant="white"
          size="sm"
          className="p-1.5"
          title={t('scenarios.redo')}
        >
          <Redo2 size={15} />
        </Button>
        <div className="w-px h-5 bg-gray-200" />
        <Button
          onClick={re.requestCancel}
          disabled={re.isSavingRoute}
          variant="white"
          size="sm"
        >
          {t('scenarios.cancel')}
        </Button>
        <Button
          onClick={re.requestSave}
          disabled={!re.canSave}
          variant="blue"
          size="sm"
          className="font-bold"
        >
          {re.isSavingRoute ? t('scenarios.routeEditSaving') : saveLabel}
        </Button>
      </div>
      {re.isAddingMark && (
        <div className="px-2 py-1 rounded bg-blue-50/95 shadow text-[11px] text-blue-700">
          {t('scenarios.addMarkHint')}
        </div>
      )}
    </div>
  )
}
